import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

import { default as RESOURCES } from '../resource';

import { ApiService } from '../../core/upgraded-providers';

@Component({
    selector: 'app-market-transaction-details',
    templateUrl: './transaction-details.component.pug',
    styleUrls: ['./transaction-details.component.less']
})
export class TransactionDetailsComponent implements OnInit {
    @Input() transaction;
    @Output() headerClick: EventEmitter<any> = new EventEmitter();

    public RESOURCES = RESOURCES;
    public owner;
    public dealer;

    constructor(
        private _apiService: ApiService
    ) {
    }

    ngOnInit() {
        if (this.transaction.market.owner) {
            this.getOwner(this.transaction.market.owner);
        }

        if (this.transaction.market.dealer) {
            this.getDealer(this.transaction.market.dealer);
        }
    }

    getOwner(id) {
        this.getUser(id)
            .then(({ user }) => this.owner = user);
    }

    getDealer(id) {
        this.getUser(id)
            .then(({ user}) => this.dealer = user);
    }

    getUser(id) {
        return this._apiService
            .get('user/find', { id });
    }

    onClick() {
        this.headerClick.emit();
    }
}
